import { Tool } from '../types';

/** 仅在有真实用户评价时展示评分/浏览量，避免展示批量灌入的假数据。 */
export function toolHasVerifiedStats(tool: Pick<Tool, 'review_count' | 'rating'>): boolean {
  const reviews = Number(tool.review_count);
  const rating = Number(tool.rating);
  if (reviews <= 0 || rating <= 0) return false;
  // 爬虫导入常见签名：5 条评价 + 4.2 分，或个位数评价 + 4.x
  if (reviews <= 10 && rating >= 4.0 && rating <= 4.99) return false;
  return true;
}
